import { set, KEY } from 'shared/lib/lib/userSettings';
import * as types from './types';

export function setSelectedInternship(internship) {
  set(KEY.SELECTED_INTERNSHIP, internship.pk);
  return { type: types.SET_SELECTED_INTERNSHIP, internship };
}
